import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { FiMail, FiPhone } from 'react-icons/fi';
import { MdOutlineFileDownload } from 'react-icons/md';
import calender from '../../../../../assets/images/calender_icon.svg';
import home from '../../../../../assets/images/home_icon.svg';
import location from '../../../../../assets/images/location_icon.svg';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { LuDot } from 'react-icons/lu';
import { GiCancel } from 'react-icons/gi';
import { Link } from 'react-router-dom';
import config from '../../../../../config/environment';
import {
  ORDER_STATUS_CUSTOMER_REJECTED,
  ORDER_STATUS_DELIVERED,
  ORDER_STATUS_ON_THE_WAY,
  ORDER_STATUS_ORDER_RECEIVED,
  ORDER_STATUS_PROCESSING,
} from '../../../../../utils/constants';

const SERVER_URL = config.SERVER_URL;
const fakeIgeURl = '/files/Product Pics_small.png';
const OrderDetailMobile: React.FC<any> = ({
  ordersDataArr,
  productsList,
  navigate,
  gotoProductDetails,
  orderStatusCode,
  handleOpenSlider,
}) => {
  return (
    <div className='bg-[#FAFAFA]'>
      <div className='flex items-center text-lg sm:text-2xl justify-between md:p-4 border-b'>
        <button
          onClick={() => navigate(-1)}
          className='flex lg:hidden items-center font-medium text-base hover:bg-red-50 rounded-lg py-1 px-2 font-poppins'
        >
          <FaArrowLeftLong className='mr-2' />
          Order Details
        </button>
        <button className='flex lg:hidden items-center font-medium text-base hover:bg-red-50 rounded-lg py-1 px-2 font-poppins'>
          <Link to='/orders/history' className=' text-[#4A2D1A] underline'>
            {' '}
            Back to List{' '}
          </Link>
        </button>
        <h2 className='hidden lg:block text-xl font-semibold font-poppins'>Order Details</h2>
      </div>
      {/* Common wrapper for all cards */}
      <div className='flex flex-col gap-4'>
        <div className='mt-4'>
          <div className='bg-white rounded-xl shadow-sm mx-3 p-3'>
            <div className='flex items-center justify-between'>
              <div className='flex flex-row gap-1 items-center'>
                <img src={calender} alt='' className='w-5 h-5' />
                <span className='font-medium font-poppins text-xs sm:text-base flex'>
                  {ordersDataArr?.transaction_date ? ordersDataArr?.transaction_date : ''}
                </span>
                <LuDot className='h-7 w-7' />
                <span className='font-medium font-poppins text-xs sm:text-base'>
                  {ordersDataArr?.total_qty} Products
                </span>
              </div>
              {/* {orderStatusCode !== ORDER_STATUS_DELIVERED && (
                <button className='flex items-center gap-1 bg-[#C12E2A] text-white text-xs font-semibold px-2 py-1 rounded-full hover:bg-[#a92623] transition-colors'>
                  <MdOutlineFileDownload size={16} />
                  <a
                    href={ordersDataArr?.sales_order_pdf_url}
                    download
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white'
                  >
                    Invoice
                  </a>
                </button>
              )} */}
            </div>

            {/* Progress Bar */}
            <div className='flex flex-1 items-start justify-between font-poppins my-2 w-full'>
              {/* Step 1 */}
              <div className='flex flex-col items-center flex-1 relative'>
                <div
                  className={`w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-xs sm:text-base font-medium transition-all duration-300
                     ${orderStatusCode >= ORDER_STATUS_ORDER_RECEIVED ? 'bg-[#552A16] text-white border-2 border-[#552A16]' : 'bg-white text-[#552A16] border-2 border-dashed border-[#552A16]'}`}
                >
                  {orderStatusCode >= ORDER_STATUS_ORDER_RECEIVED ? <FaCheck size={12} /> : 1}
                </div>
                <span className='text-[11px] sm:text-[11px] md:text-base lg:text-base mt-1 sm:mt-2 text-center leading-tight '>
                  Order Received
                </span>
                <div
                  className={`absolute top-3 sm:top-4 left-1/2 right-[-50%] h-[2px] sm:h-1 transition-all duration-300
                  ${orderStatusCode >= ORDER_STATUS_PROCESSING ? 'bg-[#552A16]' : 'bg-[#ECE0BD]'}`}
                ></div>
              </div>

              {/* Step 2 */}
              <div className='flex flex-col items-center flex-1 relative'>
                <div
                  className={`w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-xs sm:text-base font-medium transition-all duration-300
                    ${orderStatusCode >= ORDER_STATUS_PROCESSING ? 'bg-[#552A16] text-white border-2 border-[#552A16]' : 'bg-white text-[#552A16] border-2 border-dashed border-[#552A16]'}`}
                >
                  {orderStatusCode >= ORDER_STATUS_PROCESSING ? <FaCheck size={12} /> : 2}
                </div>
                <span className='text-[11px] sm:text-[11px] md:text-base lg:text-base mt-1 sm:mt-2 text-center leading-tight'>
                  Driver Assigned
                </span>
                <div
                  className={`absolute top-3 sm:top-4 left-1/2 right-[-50%] h-[2px] sm:h-1 transition-all duration-300
                     ${orderStatusCode >= ORDER_STATUS_ON_THE_WAY ? 'bg-[#552A16]' : 'bg-[#ECE0BD]'}`}
                ></div>
              </div>

              {/* Step 3 */}
              <div className='flex flex-col items-center flex-1 relative'>
                <div
                  className={`w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-xs sm:text-base font-medium transition-all duration-300
                  ${orderStatusCode >= ORDER_STATUS_ON_THE_WAY ? 'bg-[#552A16] text-white border-2 border-[#552A16]' : 'bg-white text-[#552A16] border-2 border-dashed border-[#552A16]'}`}
                >
                  {orderStatusCode >= ORDER_STATUS_ON_THE_WAY ? <FaCheck size={12} /> : 3}
                </div>
                <span className='text-[11px] sm:text-[11px] md:text-base lg:text-base mt-1 sm:mt-2 text-center leading-tight'>
                  On the Way
                </span>
                <div
                  className={`absolute top-3 sm:top-4 left-1/2 right-[-50%] h-[2px] sm:h-1 transition-all duration-300
                  ${orderStatusCode >= ORDER_STATUS_DELIVERED ? 'bg-[#552A16]' : 'bg-[#ECE0BD]'}`}
                ></div>
              </div>

              {/* Step 4 */}
              {orderStatusCode !== ORDER_STATUS_CUSTOMER_REJECTED && (
                <div className='flex flex-col items-center flex-1 relative'>
                  <div
                    className={`w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-xs sm:text-base font-medium transition-all duration-300
                 ${orderStatusCode >= ORDER_STATUS_DELIVERED ? 'bg-[#552A16] text-white border-2 border-[#552A16]' : 'bg-white text-[#552A16] border-2 border-dashed border-[#552A16]'}`}
                  >
                    {orderStatusCode >= ORDER_STATUS_DELIVERED ? <FaCheck size={12} /> : 4}
                  </div>
                  <span className='text-[11px] sm:text-[11px] md:text-base lg:text-base mt-1 sm:mt-2 text-center leading-tight'>
                    {orderStatusCode.current === 3 ? 'Delivered' : 'Deliver'}
                  </span>
                </div>
              )}
              {/* Step 4 REJECTED */}
              {orderStatusCode === ORDER_STATUS_CUSTOMER_REJECTED && (
                <div className='flex flex-col items-center flex-1 relative'>
                  <div className='w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex justify-center items-center text-center text-xs sm:text-base font-medium transition-all duration-300 bg-[#b50000] text-white border-2 border-[#b50000] '>
                    <GiCancel size={20} />
                  </div>
                  <span className='text-[11px] sm:text-[11px] md:text-base lg:text-base mt-1 sm:mt-2 text-center text-red-700 leading-tight'>
                    Rejected
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* 2. Billing Address Card */}
        {/* <div className='bg-white rounded-xl shadow-sm mx-3 p-3'>
          <div className='flex items-center gap-2 mb-1 py-2'>
            <img src={home} alt='' className='w-5 h-5' />
            <span className='text-base font-semibold text-black font-poppins'>Billing Address</span>
          </div>
          <div className='font-poppins text-sm font-semibold pb-2'>{ordersDataArr?.customer_name}</div>
          <div className='text-sm text-gray-600 font-poppins pb-2'>{ordersDataArr?.billing_address}</div>
          <div className='flex items-center gap-3 mt-2 text-sm text-gray-500 font-poppins pb-2'>
            <span className='flex items-center gap-1 '>
              <FiMail size={20} /> {ordersDataArr?.contact_email ? ordersDataArr?.contact_email : 'N/A'}
            </span>
            <span className='flex items-center gap-1'>
              <FiPhone size={20} /> {ordersDataArr?.contact_phone ? ordersDataArr?.contact_phone : 'N/A'}
            </span>
          </div>
        </div> */}

        {/* 3. Shipping Address Card */}
        <div className='bg-white rounded-xl shadow-sm mx-3 p-3'>
          <div className='flex items-center gap-2 mb-1 '>
            <img src={location} alt='' className='w-5 h-5' />
            <span className='text-base font-semibold text-black font-poppins'>Shipping Address</span>
          </div>
          <div className='font-poppins text-sm font-semibold pb-2'>{ordersDataArr?.customer_name}</div>
          <div className='text-sm text-gray-600 font-poppins pb-2'>{ordersDataArr?.shipping_address}</div>
          <div className='flex items-center gap-3 mt-2 text-sm text-gray-500 font-poppins pb-2'>
            <span className='flex items-center gap-1'>
              <FiMail size={20} /> {ordersDataArr?.contact_email ? ordersDataArr?.contact_email : 'N/A'}
            </span>
            <span className='flex items-center gap-1'>
              <FiPhone size={20} /> {ordersDataArr?.contact_phone ? ordersDataArr?.contact_phone : 'N/A'}
            </span>
          </div>
        </div>

        {/* 4. Order Items Card */}
        <div className='bg-white rounded-xl shadow-sm mx-3 p-3'>
          <div className='text-base font-semibold font-poppins mb-2 '>Order Item</div>
          {productsList.map((item: any, idx: any) => (
            <div
              key={idx}
              className='flex items-center gap-3 py-2 border-b last:border-b-0'
              onClick={() => gotoProductDetails(item.item_code)}
            >
              <img
                src={item.website_image ? `${SERVER_URL}${item.website_image}` : `${SERVER_URL}${fakeIgeURl}`}
                alt='---'
                className='w-16 h-16 object-cover rounded'
              />
              <div className='flex-1'>
                <div className='font-poppins text-sm'>{item.web_item_name}</div>
                <div className='text-xs text-[#552A16] font-poppins'>
                  {item.quantity} X {item.web_price ? Number(item.web_price).toFixed(2) : '0.00'}
                </div>
              </div>
              <div className='flex flex-col items-end'>
                <span className='font-poppins font-medium text-base text-[#00000]'>
                  ₹{item.tax_amount ? Number(item.tax_amount).toFixed(2) : '0.00'}
                </span>
              </div>
            </div>
          ))}

          {orderStatusCode === ORDER_STATUS_DELIVERED && (
            <div className='flex justify-between mt-4 mb-1 font-poppins'>
              <button
                onClick={handleOpenSlider}
                className='px-2 py-1.5 text-[#4D4D4D] rounded-lg bg-[#E6EDF5] hover:bg-[#d3e3f4] text-xs font-poppins font-semibold'
              >
                Rate Now
              </button>

              {/* <button className='flex items-center gap-1 text-xs font-semibold px-2 py-1.5 text-[#4D4D4D] rounded-lg bg-[#E6EDF5] hover:bg-[#d3e3f4] font-poppins'>
                <MdOutlineFileDownload size={16} />
                <a
                  href={ordersDataArr?.sales_order_pdf_url}
                  download
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-[#4D4D4D]'
                >
                  Invoice
                </a>
              </button> */}
            </div>
          )}
        </div>

        {/* 5. Bill Summary Card */}
        <div className='bg-white rounded-xl shadow-sm mx-3 p-4'>
          <div className='text-base font-semibold font-poppins mb-2'>Bill Summary</div>
          <div className='flex justify-between text-sm font-poppins mb-1 text-gray-400'>
            <span>Subtotal</span>
            <span>₹{ordersDataArr?.net_total ? Number(ordersDataArr?.net_total) : '0.00'}</span>
          </div>
          <div className='flex justify-between text-sm font-poppins mb-1 text-gray-400'>
            <span>
              Discount
              <span className='text-xs text-gray-400'>&nbsp;({ordersDataArr?.additional_discount_percentage})% </span>
            </span>
            <span className='text-gray-400'>
              ₹{ordersDataArr?.discount_amount ? Number(ordersDataArr?.discount_amount).toFixed(2) : '0.00'}
            </span>
          </div>
          <div className='flex justify-between text-sm font-poppins mb-1 text-gray-400'>
            <span>GST</span>
            <span>₹{ordersDataArr?.gst ? Number(ordersDataArr?.gst).toFixed(2) : '0.00'}</span>
          </div>
          <div className='flex justify-between text-sm font-poppins mb-1 text-gray-400'>
            <span>Shipping</span>
            <span className='text-green-700'>Free</span>
          </div>
          <div className='flex justify-between font-semibold text-lg font-poppins border-t border-dashed my-2 pt-2 '>
            <span>Grand Total</span>
            <span className='text-black'>
              ₹{ordersDataArr?.grand_total ? Number(ordersDataArr?.grand_total).toFixed(2) : '0.00'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailMobile;
